import { Component, Input, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { BaseComponent } from '../base/base/base-component.component';

@Component({
    selector: 'app-edit-delete',
    template: `
        <div class="d-flex flex-row gap-1">
            <button class="d-flex gap-2 align-items-center btn action-button" (click)="onEditItem()">
                <img class="icon" src="@imagesDir/edit.png" />
            </button>
            <button class="d-flex gap-2 align-items-center btn action-button" (click)="onDeleteItem()">
                <img class="icon" src="@imagesDir/cross.png" />
            </button>
        </div>
    `,
    styles: [
        `
            .icon {
                width: 24px;
                height: 24px;
                cursor: pointer;
            }
        `,
    ],
    standalone: false,
})
export class EditDeleteComponent extends BaseComponent {
    @Output()
    emitter = new Subject<{ action: string; data: any }>();

    @Input()
    data: any = {};

    ngOnInit() {}

    onDeleteItem() {
        this.emitter.next({
            action: 'delete',
            data: this.data,
        });
    }

    onEditItem() {
        this.emitter.next({
            action: 'edit',
            data: this.data,
        });
    }
}
